var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isLoading } from "../../services/behaviorSubjectService";
import { logClientRuntimeError } from "../../services/clientErrorLog";
import { sendInvoiceData, duplicateOrderData, draftOrderDetails } from "../../reduxStore/actions/salesRepDataAction";
import { getLoggedInRepDetails, getLoggedInRepDetailsFromSession, orderWiseProductsDataService, } from "../../services/apiServices/salesRepDataService";
import { EDIT_ORDER_FLAG } from "../Constant";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import store from "../../reduxStore/store";
/**
 * Shared business logic functions for SalesOrderDetails components
 * These functions are used across OrdersTableBL, PendingOrdersBL, and YourSalesBL
 */
export var handleMenuClick = function (event, order, menuAnchorEl, selectedOrder, setMenuAnchorEl, setSelectedOrder) {
    event.preventDefault();
    event.stopPropagation();
    if (menuAnchorEl && (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderId) === order.OrderId) {
        setMenuAnchorEl(null);
        setSelectedOrder(null);
    }
    else {
        setMenuAnchorEl(event.currentTarget);
        setSelectedOrder(order);
    }
};
// Closes the menu and clears the selected order
export var handleMenuClose = function (setMenuAnchorEl, setSelectedOrder) {
    setMenuAnchorEl(null);
    setSelectedOrder(null);
};
// Sends invoice for the selected order
export var handleSendInvoice = function (selectedOrder, dispatch, setMenuAnchorEl, setSelectedOrder) { return __awaiter(void 0, void 0, void 0, function () {
    var isB2BDraftOrder, emailToUse, params_1, draftOrderDetailsResponse, error_1, params, error_2;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!selectedOrder) return [3 /*break*/, 8];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 7, , 8]);
                isLoading.next(true);
                isB2BDraftOrder = (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.B2BCompanyName) &&
                    (((_a = selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "open" || ((_b = selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "voided");
                emailToUse = selectedOrder.CustomerEmail || "";
                if (!(isB2BDraftOrder && !emailToUse)) return [3 /*break*/, 5];
                _d.label = 2;
            case 2:
                _d.trys.push([2, 4, , 5]);
                params_1 = {
                    order_id: selectedOrder.OrderId,
                };
                return [4 /*yield*/, dispatch(draftOrderDetails(params_1, ""))];
            case 3:
                draftOrderDetailsResponse = _d.sent();
                if (draftOrderDetailsResponse === null || draftOrderDetailsResponse === void 0 ? void 0 : draftOrderDetailsResponse.draftOrder) {
                    // Try to get email from draftOrderObj.email or draftOrderObj.customer?.email
                    emailToUse = draftOrderDetailsResponse.draftOrder.email ||
                        ((_c = draftOrderDetailsResponse.draftOrder.customer) === null || _c === void 0 ? void 0 : _c.email) ||
                        selectedOrder.CustomerEmail ||
                        "";
                }
                return [3 /*break*/, 5];
            case 4:
                error_1 = _d.sent();
                logClientRuntimeError("handleSendInvoice.B2BDraftEmail", error_1);
                return [3 /*break*/, 5];
            case 5:
                params = {
                    orderid: selectedOrder.OrderId,
                    emailid: emailToUse,
                };
                return [4 /*yield*/, dispatch(sendInvoiceData(params))];
            case 6:
                _d.sent();
                isLoading.next(false);
                return [3 /*break*/, 8];
            case 7:
                error_2 = _d.sent();
                isLoading.next(false);
                return [3 /*break*/, 8];
            case 8:
                handleMenuClose(setMenuAnchorEl, setSelectedOrder);
                return [2 /*return*/];
        }
    });
}); };
// Handles printing invoice from menu (only used for paid orders)
export var handlePrintFromMenu = function (selectedOrder, setMenuAnchorEl, setSelectedOrder, setPrintInvoiceData, setOpenPrintInvoiceDialog) { return __awaiter(void 0, void 0, void 0, function () {
    var params, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                handleMenuClose(setMenuAnchorEl, setSelectedOrder);
                if (!selectedOrder) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                isLoading.next(true);
                params = {
                    order_id: selectedOrder.OrderId,
                    clientId: 0,
                };
                return [4 /*yield*/, orderWiseProductsDataService(params)];
            case 2:
                response = _a.sent();
                if (response && response.singleOrderDetailsFromShopify && response.ProductDetails && response.ProductDetails.length > 0) {
                    setPrintInvoiceData(response);
                    setOpenPrintInvoiceDialog(true);
                }
                isLoading.next(false);
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                isLoading.next(false);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Handles print invoice click
 */
export var handlePrintInvoiceClick = function (item, setPrintInvoiceData, setOpenPrintInvoiceDialog) { return __awaiter(void 0, void 0, void 0, function () {
    var params, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                isLoading.next(true);
                params = {
                    order_id: item.OrderId,
                    clientId: 0,
                };
                return [4 /*yield*/, orderWiseProductsDataService(params)];
            case 1:
                response = _a.sent();
                if (response) {
                    setPrintInvoiceData(response);
                    setOpenPrintInvoiceDialog(true);
                }
                isLoading.next(false);
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                isLoading.next(false);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/** Same URL contract as Your Sales → Print (tenant print page with hmac). */
export function buildPrintInvoicesBySalesRepUrl(order) {
    var _a;
    var base = store.getState().salesRepData.baseData.salesRepUrl;
    var hmac = store.getState().salesRepData.baseData.hmac;
    var shopName = getLoggedInRepDetails().shopName;
    if (!base || !hmac || (order === null || order === void 0 ? void 0 : order.OrderId) == null || !shopName) {
        return null;
    }
    var customerName = (_a = order.CustomerName) !== null && _a !== void 0 ? _a : "";
    return (base +
        "/SalesRepTenant/PrintInvoicesBySalesRep?hmac=" +
        hmac +
        "&customerName=" +
        customerName +
        "&orderId=" +
        order.OrderId +
        "&shop=" +
        shopName);
}
//Handles duplicate order
export var handleDuplicateOrder = function (selectedOrder, orders, dispatch, setMenuAnchorEl, setSelectedOrder) { return __awaiter(void 0, void 0, void 0, function () {
    var latestOrderFromStore, orderToUse, orderIdToUse, status_1, isDraftOrder, params, duplicateResponse, update_ActiveTab_InReduxStore;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                handleMenuClose(setMenuAnchorEl, setSelectedOrder);
                if (!selectedOrder) return [3 /*break*/, 2];
                isLoading.next(true);
                latestOrderFromStore = orders.find(function (order) { return order.OrderId === selectedOrder.OrderId; });
                orderToUse = latestOrderFromStore || selectedOrder;
                orderIdToUse = (orderToUse === null || orderToUse === void 0 ? void 0 : orderToUse.OrderId) || selectedOrder.OrderId;
                status_1 = (orderToUse === null || orderToUse === void 0 ? void 0 : orderToUse.OrderStatus) ? orderToUse.OrderStatus.toLowerCase() : "";
                isDraftOrder = ["open", "voided", "pending"].includes(status_1);
                params = {
                    order_id: orderIdToUse,
                    isDraftOrder: isDraftOrder,
                };
                return [4 /*yield*/, dispatch(duplicateOrderData(params, EDIT_ORDER_FLAG))];
            case 1:
                duplicateResponse = _a.sent();
                // Check if we have draftOrder and at least some data (ProductDetails can be empty for orders with no items)
                if (duplicateResponse && duplicateResponse.draftOrder && Object.keys(duplicateResponse.draftOrder).length > 0) {
                    update_ActiveTab_InReduxStore = {
                        payload: { activeTabIndex: 1, actionEvent: EDIT_ORDER_FLAG },
                        type: SalesRepDataActionType.ACTIVE_TAB,
                    };
                    dispatch(update_ActiveTab_InReduxStore);
                }
                else {
                    alert("Unable to duplicate this order. The backend did not return complete order data.");
                }
                isLoading.next(false);
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Merges customer data from activeClientObj into Redux editDraftOrder state
 * Used after duplicating orders to preserve customer information
 */
export var mergeCustomerDataToRedux = function (activeClientObj, dispatch) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var currentEditDraftOrder = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder;
    if (currentEditDraftOrder === null || currentEditDraftOrder === void 0 ? void 0 : currentEditDraftOrder.draftOrderObj) {
        var updatedCustomer = __assign({}, currentEditDraftOrder.draftOrderObj.customer);
        if (activeClientObj && activeClientObj.customer) {
            updatedCustomer = {
                id: ((_b = activeClientObj.customer) === null || _b === void 0 ? void 0 : _b.id) || activeClientObj.customer_id || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.id) || "",
                email: ((_c = activeClientObj.customer) === null || _c === void 0 ? void 0 : _c.email) || activeClientObj.email || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.email) || "",
                first_name: ((_d = activeClientObj.customer) === null || _d === void 0 ? void 0 : _d.first_name) || ((_e = activeClientObj.customer) === null || _e === void 0 ? void 0 : _e.firstName) || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.first_name) || "",
                last_name: ((_f = activeClientObj.customer) === null || _f === void 0 ? void 0 : _f.last_name) || ((_g = activeClientObj.customer) === null || _g === void 0 ? void 0 : _g.lastName) || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.last_name) || "",
                tags: ((_h = activeClientObj.customer) === null || _h === void 0 ? void 0 : _h.tags) || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.tags) || null,
                tax_exempt: (_l = (_k = (_j = activeClientObj.customer) === null || _j === void 0 ? void 0 : _j.tax_exempt) !== null && _k !== void 0 ? _k : updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.tax_exempt) !== null && _l !== void 0 ? _l : false,
            };
        }
        else {
            // Fallback to Sales Rep's customer ID if customer data is missing
            var salesRepCustomerId = getLoggedInRepDetailsFromSession().CustomerId;
            if (!(updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.id) || updatedCustomer.id === 0) {
                updatedCustomer = __assign(__assign({}, updatedCustomer), { id: salesRepCustomerId || (updatedCustomer === null || updatedCustomer === void 0 ? void 0 : updatedCustomer.id) || "" });
            }
        }
        // Update Redux with merged customer data
        var action = {
            payload: __assign(__assign({}, currentEditDraftOrder), { draftOrderObj: __assign(__assign({}, currentEditDraftOrder.draftOrderObj), { customer: updatedCustomer }), originalLineItems: (_m = currentEditDraftOrder === null || currentEditDraftOrder === void 0 ? void 0 : currentEditDraftOrder.originalLineItems) !== null && _m !== void 0 ? _m : [], isDuplicate: (_o = currentEditDraftOrder === null || currentEditDraftOrder === void 0 ? void 0 : currentEditDraftOrder.isDuplicate) !== null && _o !== void 0 ? _o : true }),
            type: SalesRepDataActionType.EDIT_DRAFT_ORDER,
        };
        dispatch(action);
    }
};
/**
 * Calculates the B2B tab index based on active tabs
 * Returns the index of the B2B tab in the filtered active tabs array
 */
export var calculateB2BTabIndex = function (selectFeatures) {
    // Tab indices: 0=Dashboard, 1=CreateOrder, 2=B2B, 3=Affiliate, etc.
    // We need to count active tabs before B2B tab (index 2)
    var activeTabsBeforeB2B = 0;
    // Dashboard (index 0) is always active
    activeTabsBeforeB2B++;
    // Create Order tab (index 1) - check if active
    if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateInvoice) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateOrder)) {
        activeTabsBeforeB2B++;
    }
    // B2B tab (index 2) is at position activeTabsBeforeB2B in the filtered array
    return activeTabsBeforeB2B;
};
/**
 * Handles duplicate order from dialog (for paid/unpaid/draft orders)
 * Includes customer data merging logic
 */
export var handleDuplicateOrderFromDialog = function (activeClientObj, orderId, isDraftOrder, dispatch, setAlertErrorMsg, t) { return __awaiter(void 0, void 0, void 0, function () {
    var orderIdToUse, params, response, update_ActiveTab_InReduxStore, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!activeClientObj || (!activeClientObj.id && !activeClientObj.order_id && !orderId)) {
                    if (setAlertErrorMsg && t) {
                        setAlertErrorMsg({ msg: t("draftOrder_DuplicateErrorMsg_MissingInfo"), open: true, severity: "error" });
                    }
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                isLoading.next(true);
                orderIdToUse = orderId || activeClientObj.id || activeClientObj.order_id;
                params = {
                    order_id: Number(orderIdToUse),
                    isDraftOrder: isDraftOrder,
                };
                return [4 /*yield*/, dispatch(duplicateOrderData(params, EDIT_ORDER_FLAG))];
            case 2:
                response = _a.sent();
                if (!(response === null || response === void 0 ? void 0 : response.draftOrder) || Object.keys(response.draftOrder).length === 0) {
                    if (setAlertErrorMsg && t) {
                        setAlertErrorMsg({ msg: t("draftOrder_DuplicateErrorMsg_TryAgain"), open: true, severity: "error" });
                    }
                    isLoading.next(false);
                    return [2 /*return*/];
                }
                // Wait a moment for Redux state to update after duplicateOrderData dispatch
                return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
            case 3:
                // Wait a moment for Redux state to update after duplicateOrderData dispatch
                _a.sent();
                // Merge customer data if available
                if (activeClientObj) {
                    mergeCustomerDataToRedux(activeClientObj, dispatch);
                }
                update_ActiveTab_InReduxStore = {
                    payload: { activeTabIndex: 1, actionEvent: EDIT_ORDER_FLAG },
                    type: SalesRepDataActionType.ACTIVE_TAB,
                };
                dispatch(update_ActiveTab_InReduxStore);
                isLoading.next(false);
                return [3 /*break*/, 5];
            case 4:
                error_5 = _a.sent();
                if (setAlertErrorMsg && t) {
                    setAlertErrorMsg({ msg: t("draftOrder_DuplicateErrorMsg_General"), open: true, severity: "error" });
                }
                isLoading.next(false);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Handles print invoice from dialog
 * Unified handler for printing from dialog boxes
 */
export var handlePrintFromDialog = function (activeClientObj, setPrintInvoiceData, setOpenPrintInvoiceDialog) { return __awaiter(void 0, void 0, void 0, function () {
    var orderItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!activeClientObj) return [3 /*break*/, 2];
                orderItem = {
                    OrderId: activeClientObj.order_id || activeClientObj.id || activeClientObj.OrderId,
                };
                return [4 /*yield*/, handlePrintInvoiceClick(orderItem, setPrintInvoiceData, setOpenPrintInvoiceDialog)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * Handles send invoice from dialog
 * Unified handler for sending invoice from dialog boxes
 */
export var handleSendInvoiceFromDialog = function (activeClientObj, dispatch, setAlertErrorMsg, setSuccessFlag, t) { return __awaiter(void 0, void 0, void 0, function () {
    var params, sendInvoiceResponse, error_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!activeClientObj || (!activeClientObj.id && !activeClientObj.order_id)) {
                    if (setAlertErrorMsg && t) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    }
                    return [2 /*return*/];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                isLoading.next(true);
                params = {
                    orderid: activeClientObj.id || activeClientObj.order_id,
                    emailid: ((_a = activeClientObj.customer) === null || _a === void 0 ? void 0 : _a.email) || activeClientObj.email || "",
                };
                return [4 /*yield*/, dispatch(sendInvoiceData(params))];
            case 2:
                sendInvoiceResponse = _b.sent();
                if (sendInvoiceResponse) {
                    if (setSuccessFlag) {
                        setSuccessFlag(true);
                        setTimeout(function () {
                            setSuccessFlag(false);
                        }, 3000);
                    }
                    if (setAlertErrorMsg && t) {
                        setAlertErrorMsg({ msg: t("sendInvoice_successMsg"), open: true, severity: "success" });
                    }
                }
                isLoading.next(false);
                return [3 /*break*/, 4];
            case 3:
                error_6 = _b.sent();
                if (setAlertErrorMsg && t) {
                    setAlertErrorMsg({ msg: t("onSuccessInvoiceFailedMsg"), open: true, severity: "error" });
                }
                isLoading.next(false);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
